import { create } from 'zustand'

interface TenantSettings {
  targetAnnuale?: number
  currency: string
  fiscalYearStart: number // month 1-12
  serviceLines: string[]
  alertThresholds: Record<string, number>
}

interface TenantState {
  tenantId: string | null
  tenantName: string | null
  plan: 'trial' | 'starter' | 'growth' | 'enterprise' | null
  settings: TenantSettings | null
  setTenant: (id: string, name: string, plan: TenantState['plan'], settings: TenantSettings) => void
  clearTenant: () => void
}

export const useTenantStore = create<TenantState>((set) => ({
  tenantId: null,
  tenantName: null,
  plan: null,
  settings: null,
  setTenant: (id, name, plan, settings) =>
    set({ tenantId: id, tenantName: name, plan, settings }),
  clearTenant: () =>
    set({ tenantId: null, tenantName: null, plan: null, settings: null }),
}))
